export function SlimeUpIcon({ width = 60 }: { width?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      version="1.1"
      viewBox="0 0 16 65.837"
    >
      <g transform="translate(-57.584 -23.825)">
        <rect
          width="13.926"
          height="42.377"
          x="59.526"
          y="35.434"
          strokeWidth="0.265"
          rx="6.963"
          ry="3.423"
        ></rect>
        <path
          strokeWidth="0.195"
          d="M59.587 23.923c.514 0 .978.382 1.313 1.001.336.62.402 1.512.543 2.425l1.376 8.937v40.902l-1.38 8.95c-.14.917-.206 1.805-.542 2.425-.335.619-.8 1.001-1.314 1.001-1.028 0-2.14-1.59-1.856-3.427l1.38-8.949V36.286l-1.377-8.937c-.281-1.826.828-3.426 1.857-3.426z"
        ></path>
      </g>
    </svg>
  );
}
